import { render, staticRenderFns } from "./TheSurvey.vue?vue&type=template&id=ba24feae&"
import script from "./TheSurvey.vue?vue&type=script&lang=js&"
export * from "./TheSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports